import { Settings, Edit3 } from 'lucide-react';
import { useGlobalStates } from '../globalConstants';
import { useEffect } from 'react';

export default function DifficultySettings() {
    const { difficultyLevel, setDifficultyLevel, socket, setDisplayEditor, setScenario, scenario, setMessages } = useGlobalStates();

    const settingsMap = {
        'Easy': 'easy',
        'Normal': 'normal',
        'Hard': 'hard',
    };

    const setDifficulty = (level) => {
        if (level !== difficultyLevel) {
            setMessages([]);
            socket.emit("soft-reset");
        }
        setDifficultyLevel(level);
        socket.emit("change_difficulty", { difficulty: level });
    };

    useEffect(() => {
        socket.on("updated_scenarios", (data) => {
            setScenario(data);
        });
        return () => {
            socket.off("updated_scenarios");
        };
    }, []);

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
            <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                <Settings className="h-4 w-4 mr-2" />
                Settings
            </h3>
            <div className="space-y-2">
                {Object.entries(settingsMap).map(([displayName, difficulty]) => (
                    <button
                        key={difficulty}
                        className={`w-full text-left px-3 py-2 text-sm rounded-lg transition-colors ${
                            difficultyLevel?.toLowerCase() === difficulty
                            ? difficulty === 'easy'
                                ? 'bg-green-50 text-green-700 border border-green-200'
                                : difficulty === 'hard' 
                                ? 'bg-red-50 text-red-700 border border-red-200' 
                                : 'bg-orange-50 text-orange-700 border border-orange-200'
                            : 'hover:bg-gray-50 text-gray-700'
                        }`}
                        onClick={() => setDifficulty(difficulty)}
                    >
                        <div className="flex items-center justify-between">
                            <span className="font-medium">
                                {displayName}
                            </span>
                            {/* <div className="flex items-center space-x-2">
                                <span
                                    role="button"
                                    tabIndex={0}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setDisplayEditor(true);
                                    }}
                                    className="p-1 rounded-full hover:bg-current hover:bg-opacity-20 transition-colors cursor-pointer"
                                    title="Edit scenario"
                                >
                                    <Edit3 className="h-3 w-3" />
                                </span>
                                {difficultyLevel?.toLowerCase() === difficulty && (
                                    <div className="w-2 h-2 rounded-full bg-current"></div>
                                )}
                            </div> */}
                        </div>
                        <p className="text-xs mt-1 opacity-75">
                            {difficulty === 'easy' 
                                ? 'Agents are more open to interventions'
                                : difficulty === 'hard' 
                                ? 'Agents are highly resistant' 
                                : 'Realistic responses to therapy'}
                        </p> 
                    </button>
                ))}
            </div>
        </div>
    );
}